import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Toaster } from "@/components/ui/toaster";

import LoginPage from "@/pages/LoginPage";
import TeamPage from "@/pages/TeamPage";
import SettingsPage from "@/pages/SettingsPage";
import ProfilePage from "@/pages/ProfilePage";
import AcademyHomePage from "@/pages/academy/AcademyHomePage";
import AcademyLeadsPage from "@/pages/academy/AcademyLeadsPage";
import AcademyStudentsPage from "@/pages/academy/AcademyStudentsPage";
import AcademyStudentPage from "@/pages/academy/AcademyStudentPage";
import AcademyCoursesPage from "@/pages/academy/AcademyCoursesPage";
import AcademySettingsPage from "@/pages/academy/AcademySettingsPage";
import AcademyCashPage from "@/pages/academy/AcademyCashPage";
import AcademyFinancePage from "@/pages/academy/AcademyFinancePage";
import AcademyCommissionsPage from "@/pages/academy/AcademyCommissionsPage";
import AcademyPracticesPage from "@/pages/academy/AcademyPracticesPage";
import EnrollmentPortalPage from "@/pages/public/EnrollmentPortalPage";
import LandingPage from "@/pages/public/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Fix J (2026-10-27): web publica de la academia (catalogo y consultas), sin sesion */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* pagina personal del alumno (link del email), sin sesion */}
            <Route path="/inscripcion/:token" element={<EnrollmentPortalPage />} />

            <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/academia" element={<ProtectedRoute academy={[]}><AcademyHomePage /></ProtectedRoute>} />
              <Route path="/academia/interesados" element={<ProtectedRoute academy={["executive"]}><AcademyLeadsPage /></ProtectedRoute>} />
              <Route path="/academia/alumnos" element={<ProtectedRoute academy={[]}><AcademyStudentsPage /></ProtectedRoute>} />
              <Route path="/academia/alumnos/:studentId" element={<ProtectedRoute academy={[]}><AcademyStudentPage /></ProtectedRoute>} />
              <Route path="/academia/cursos" element={<ProtectedRoute academy={[]}><AcademyCoursesPage /></ProtectedRoute>} />
              {/* Fix D (2026-10-18): practicas del dia */}
              <Route path="/academia/practicas" element={<ProtectedRoute academy={["reception", "academic", "instructor"]}><AcademyPracticesPage /></ProtectedRoute>} />
              <Route path="/academia/configuracion" element={<ProtectedRoute academy={["finance"]}><AcademySettingsPage /></ProtectedRoute>} />
              <Route path="/academia/caja" element={<ProtectedRoute academy={["reception", "finance"]}><AcademyCashPage /></ProtectedRoute>} />
              <Route path="/academia/finanzas" element={<ProtectedRoute academy={["finance"]}><AcademyFinancePage /></ProtectedRoute>} />
              <Route path="/academia/comisiones" element={<ProtectedRoute academy={["executive", "finance", "instructor"]}><AcademyCommissionsPage /></ProtectedRoute>} />
              <Route path="/equipo" element={<ProtectedRoute allowedRoles={["admin"]}><TeamPage /></ProtectedRoute>} />
              <Route path="/configuracion" element={<ProtectedRoute allowedRoles={["admin"]}><SettingsPage /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
